export default __webpack_public_path__ + "static/media/venmo.f3aaf0d1.svg";